export async function getCurrentChain(connector) {
    return await connector.request({ method: 'eth_chainId' }).then(
        result => {
            return result;
        }, error => {
            return null;
        });
}